import { render, staticRenderFns } from "./IsAwareOfPublicWorksQuestion.vue?vue&type=template&id=59f1d02a&scoped=true"
import script from "./IsAwareOfPublicWorksQuestion.vue?vue&type=script&lang=ts"
export * from "./IsAwareOfPublicWorksQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f1d02a",
  null
  
)

export default component.exports